import React, { createContext, useContext, useEffect, useState } from "react";

import { lstFuncoesInterface } from "../../Interfaces/Geral/Grupos/GruposFuncaoInterface";
import { GrupoInterface } from "../../Interfaces/Geral/Grupos/GrupoInterfaces";

import { GetUserInfor } from "../../Controllers/Users/UsersController";
import { IDOrganizacaoInterface } from "../../Interfaces/Organizacao/Organizacao";
import { GetOrganizacaoController } from "../../Controllers/Organizacao/Organizacao";
import { IConfigGeral } from "../../Interfaces/Geral/GestaoDeCadastro/ConfigGeral/ConfigGeralInterface";
import { GetConfigGeralController } from "../../Controllers/Geral/GestaoDeCadastros/ConfigGeral/ConfigGeralController";
import Swal from "sweetalert2";
import { LoginAgenteController } from "../../Controllers/Geral/Telefonia/TelefoniaController";
import { GoOnlineCRMV2Controller } from "../../Controllers/Login/OnlineControl/OnlineControlControllers";
import useAsyncEffect from "../../hooks/useAsyncEffect";
import { ConfigGeralVendasGetController } from "../../Controllers/Vendas/ConfigGeral/ConfigGeralService";
import { IConfigGeralVendas } from "../../Interfaces/Vendas/ConfigGeral/ConfigGeralInterface";

export interface ITelasInterface {
    DS_DESCRICAO_TELA: string;
    DS_NOME_TELA: string;
    DS_URL_TELA: string;
    FL_ATIVO: boolean;
    FL_MENU_ATIVO: boolean;
    FL_NOVA_TELA: boolean;
    ID_SISTEMA: number;
    ID_TELA: number;
    ID_TELA_PAI: number;
    NR_ORDEM: number;
}
export interface IModuloBase {
    ID_MODULO: number;
    DS_MODULO: string;
}
export interface IModuloInterface extends IModuloBase {
    DS_DESCRICAO: string;
    FL_ATIVO: boolean;
}
export interface ITelasUsuario extends Array<ITelasInterface> {
    TemAcesso: (telasId: number[]) => boolean;
}

export interface IUserInfor {
    ID_USUARIO?: number;
    DS_EMAIL?: string;
    DS_NOME?: string;
    DS_LOGIN?: string;
    DS_SENHA?: string;
    ID_RAMAL_DISCADOR?: number;
    NR_AGENTE_DISCADOR?: number;
    NR_RG: string;
    NR_CPF: string;
    FL_ADMINISTRADOR: boolean;
    FL_ATIVO: boolean;
    DS_LOGIN_UAU: string;
    DS_SENHA_UAU: string;
    FUNCOES: Array<lstFuncoesInterface>;
    GRUPOS: Array<GrupoInterface>;
    MODULOS: Array<IModuloInterface>;
    TELAS: Array<ITelasInterface>;
    ID_MODULO_PRINCIPAL: number;
    ID_PERFIL_USUARIO: number;
    token: string | null;
}

interface IUserContext {
    UserInfor: IUserInfor;
    setUserInfor: (UserInfor: IUserInfor) => void;
    OrgInfor: IDOrganizacaoInterface;
    setOrgInfor: (OrgInfor: IDOrganizacaoInterface) => void;
    Config: IConfigGeral;
    updateConfig: () => void;

    getConfigGeralVendas: IConfigGeralVendas[] | undefined;
    getConfigGeralVendasLoading: boolean;
    getConfigGeralVendasExec: (
        ...args: any[]
    ) => Promise<IConfigGeralVendas[] | undefined>;
}

const UserContext = createContext<IUserContext>({} as IUserContext);

function alertStorageChange(token: string | null, logou?: boolean) {
    Swal.fire({
        title: `Você ${!logou ? "des" : ""}logou em outra aba.`,
        icon: "info",
        buttonsStyling: false,
        showConfirmButton: !!token,
        confirmButtonText: "Manter-se logado nessa aba",
        showCancelButton: true,
        cancelButtonText: "Recarregar página",
        customClass: {
            confirmButton: "btn btn-outline-success",
            cancelButton: "btn btn-outline-info",
        },
        allowEscapeKey: false,
        allowOutsideClick: false,
    }).then((result) => {
        if (result.isConfirmed) {
            if (token) window.localStorage.setItem("@token", token);
        } else if (
            result.isDismissed &&
            result.dismiss /* result.dismiss é undefined quando o alert é fechado manualmente com Swal.close() */
        ) {
            window.location.reload();
        }
    });
}

export default function Userprovider({ children }: any) {
    const [UserInfor, setUserInfor] = useState<IUserInfor>({} as IUserInfor);
    const [OrgInfor, setOrgInfor] = useState<IDOrganizacaoInterface>(
        {} as IDOrganizacaoInterface
    );
    const [Config, setConfig] = useState<IConfigGeral>({} as IConfigGeral);

    window.onstorage = (e: StorageEvent) => {
        if (e.key === "@token" && UserInfor && OrgInfor) {
            if (e.newValue) {
                Promise.all([GetOrganizacaoController(), GetUserInfor()]).then(
                    (res) => {
                        const [org, user] = res;
                        if (
                            OrgInfor.ID_ORGANIZACAO !== org?.ID_ORGANIZACAO ||
                            UserInfor.ID_USUARIO !== user?.ID_USUARIO
                        )
                            alertStorageChange(UserInfor.token, true);
                        else Swal.close();
                    }
                );
            } else alertStorageChange(UserInfor.token);
        }
    };

    useEffect(() => {
        if (localStorage.getItem("@token")) {
            GetOrganizacaoController().then((res) => {
                setOrgInfor(res);
            });
            GetUserInfor().then((res) => {
                setUserInfor({ ...res, token: localStorage.getItem("@token") });
            });
            updateConfig();
        }
    }, []);

    useEffect(() => {
        if (OrgInfor && UserInfor && UserInfor.ID_USUARIO) {
            GoOnlineCRMV2Controller(
                OrgInfor.ID_ORGANIZACAO,
                UserInfor.ID_USUARIO
            );
        }
    }, [OrgInfor, UserInfor]);

    useEffect(() => {
        if (
            Config?.ConfigUraIntegracaoTelefoniaDTO?.FL_INTEGRACAO_URA_CRM &&
            Config?.ConfigUraIntegracaoTelefoniaDTO?.ID_INTEGRADOR_URA &&
            UserInfor?.ID_RAMAL_DISCADOR &&
            UserInfor?.NR_AGENTE_DISCADOR
        ) {
            LoginAgenteController();
        }
    }, [Config, UserInfor]);

    function updateConfig() {
        GetConfigGeralController().then((res) => {
            setConfig(res);
        });
    }

    const {
        value: getConfigGeralVendas,
        loading: getConfigGeralVendasLoading,
        execute: getConfigGeralVendasExec,
    } = useAsyncEffect(async () => {
        if (localStorage.getItem("@token"))
            return ConfigGeralVendasGetController();
    }, [localStorage.getItem("@token")]);

    return (
        <UserContext.Provider
            value={{
                UserInfor,
                setUserInfor,
                OrgInfor,
                setOrgInfor,
                Config,
                updateConfig,

                getConfigGeralVendas,
                getConfigGeralVendasLoading,
                getConfigGeralVendasExec,
            }}
        >
            {children}
        </UserContext.Provider>
    );
}

//Criação do hook
export function useUserInfor() {
    const UserInforContext = useContext(UserContext);
    if (!UserInforContext)
        throw new Error(
            "useUserInfor necessita de um Userprovider em volta do que sera utilizado"
        );

    const { UserInfor, setUserInfor } = UserInforContext;
    const { OrgInfor, setOrgInfor } = UserInforContext;
    const { Config, updateConfig } = UserInforContext;
    const {
        getConfigGeralVendas,
        getConfigGeralVendasLoading,
        getConfigGeralVendasExec,
    } = UserInforContext;

    return {
        UserInfor,
        OrgInfor,
        setOrgInfor,
        setUserInfor,
        Config,
        updateConfig,

        getConfigGeralVendas,
        getConfigGeralVendasLoading,
        getConfigGeralVendasExec,
    };
}
